// extracted by mini-css-extract-plugin
export default {"main-menu":"main-menu_main-menu__U1IbD","search-container":"main-menu_search-container__AlNlT","home":"main-menu_home__6GWhV","result-container":"main-menu_result-container__JNiqN"};